import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { RoyalCrown } from './RoyalCrown';

export const RANK_META = {
  Initiate: { color: '#C9B48A', line: 'The journey has begun.' },
  Knight: { color: '#5DD4FF', line: 'You have proven your word. Rise, Knight.' },
  Champion: { color: '#5BE08A', line: 'Discipline is now who you are.' },
  Sovereign: { color: '#B978FF', line: 'You rule your mind. The realm bows.' },
  Emperor: { color: '#FFD45C', line: 'The summit. Unshakable. Unstoppable.' },
};

/* Rank promotion ceremony — crest rises through light pillars. */
export const RankUp = ({ rank, points, onDone }) => {
  useEffect(() => { const t = setTimeout(onDone, 4600); return () => clearTimeout(t); }, [onDone]);
  const m = RANK_META[rank] || RANK_META.Knight;
  return (
    <motion.div className="fixed inset-0 z-[315] flex flex-col items-center justify-center text-center px-8" onClick={onDone}
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="oath-rank-up"
      style={{ background: `radial-gradient(circle at 50% 40%, ${m.color}40, #030306 65%), #030306` }}>
      {[-90, -45, 0, 45, 90].map((x, i) => (
        <motion.span key={x} className="absolute bottom-0 w-[2px]" style={{ left: `calc(50% + ${x}px)`, background: `linear-gradient(0deg, transparent, ${m.color}, transparent)` }}
          initial={{ height: 0, opacity: 0 }} animate={{ height: '75%', opacity: [0, 0.9, 0.4] }} transition={{ delay: i * 0.08, duration: 1.2 }} />
      ))}
      <motion.p className="font-['Outfit'] text-[10px] tracking-[0.5em] uppercase" style={{ color: m.color }} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}>Promotion</motion.p>
      <motion.div initial={{ y: 80, scale: 0.5, opacity: 0 }} animate={{ y: 0, scale: 1, opacity: 1 }} transition={{ type: 'spring', stiffness: 160, damping: 14, delay: 0.4 }} className="mt-5">
        <RoyalCrown size={150} />
      </motion.div>
      <motion.p className="font-['Cinzel'] text-4xl mt-5" style={{ color: m.color, textShadow: `0 0 24px ${m.color}` }}
        initial={{ opacity: 0, letterSpacing: '0.6em' }} animate={{ opacity: 1, letterSpacing: '0.2em' }} transition={{ delay: 1, duration: 0.8 }}>{rank.toUpperCase()}</motion.p>
      <motion.p className="font-['Cormorant_Garamond'] italic text-xl text-white/80 mt-3" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.6 }}>{m.line}</motion.p>
      <motion.p className="font-['Outfit'] text-xs text-white/40 mt-4" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 2 }}>{points} total power</motion.p>
    </motion.div>
  );
};

export default RankUp;
